import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RecuperarInfoService } from '../../services/recuperarInfo/recuperar-info.service';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ConfigurationService } from '../../services/configuration/configuration.service';


import { MensajeRespuestaDTO } from '../../model/mensajeRespuestaDTO';
import { NgxSpinnerService } from 'ngx-spinner';
//Variable del global scope para utilizar jquery
declare var $: any;

@Component({
  selector: 'app-cambiar-contrasenia',
  templateUrl: './cambiar-contrasenia.component.html',
  styleUrls: ['./cambiar-contrasenia.component.css']
})

export class CambiarContraseniaComponent implements OnInit {

  /**
   * Lenduaje del navegador.
   */
  public defaultLanguage: string;

  /**
   * Atributo que contiene el token de solicitud de cambio.
   */
  public token: string;

  /**
   * Atributo que contiene el id del usuario que solicito el cambio.
   */
  public id: string;

  /**
   * Atributo que indica si el token es valido.
   */
  public validado: boolean;

  /**
   * Atributo que contiene el mensaje de error generado por la consulta.
   */
  public mensajeSalida: MensajeRespuestaDTO;

  /**
   * Atributo formulario que contiene información de autenticación.
   */
  public profileForm: UntypedFormGroup;

  /**
   * Atributo que contiene el nombre de usuario para validar el token
   */
  public userName: string;

  /**
   * Constructor por default.
   * @param _activatedRoute 
   */
  constructor(private _activatedRoute: ActivatedRoute,
              private _infoService: RecuperarInfoService,
              private _translateService: TranslateService,
              private _configurationService: ConfigurationService,
              private _formB: UntypedFormBuilder,
              private _spinner: NgxSpinnerService) {
      this.mensajeSalida = new MensajeRespuestaDTO('','','');
      this.getNavigatorLang();
      this._translateService.addLangs(["es", "en"]);
      this._translateService.use(this.defaultLanguage);

      this._activatedRoute.queryParams.subscribe(data => {
        this.token = data['token'];
        this.id = data['id'];
        this.userName = data['userName'];
      });
    
      this._infoService.validarToken(this.id, this.token, this.userName).then(
        res => {
          if(res.estadoMensaje == 'OK') {
            this.validado = true;
          } else {
            this.mensajeSalida = res;
          }
        }, err => {
          this.mensajeSalida.mensaje = err.mensaje;
        }
      );

   }

   /**
    * 
    */
  ngOnInit() {
    this._configurationService.inhabilitarBotonAtras();
    this._spinner.show();
    this.profileForm = this._formB.group({
    password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/.#])([A-Za-z\d$@$!%*?&/.#]|[^ ]){8,20}$/)]],
    repetirPassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/.#])([A-Za-z\d$@$!%*?&/.#]|[^ ]){8,20}$/)]]});
    this._spinner.hide();
  }

  /**
     * Se encarga de consultar el idioma del navegador
     */
    private getNavigatorLang() {
      this.defaultLanguage = this._translateService.getBrowserLang();
      if (this.defaultLanguage != 'es' && this.defaultLanguage != 'en') {
          this.defaultLanguage = 'es';
      }
  }
  
  /**
   * Método que se encarga de actualizar la contraseña.
   */
  public cambiarContrasenia() {
    this._spinner.show();
    var password = this.profileForm.get('password').value;
    var repetirPassword = this.profileForm.get('repetirPassword').value;
    
    if(password==repetirPassword) {
      this._infoService.cambiarContrasenia(password, this.id).then(
        res => {
          this.mensajeSalida = res;
          $('#verRespuesta').modal({show: 'true'});
          this._spinner.hide();
        }, err => {
          this.mensajeSalida = err;
          $('#verRespuesta').modal({show: 'true'});
          this._spinner.hide();
        }
      );
    } else {
      this.mensajeSalida.estadoMensaje = "ERROR"
      this.mensajeSalida.mensaje = "Las contraseñas deben ser iguales.";
          $('#verRespuesta').modal({show: 'true'});
          this._spinner.hide();
    }
  }
}